import React, { useState, useContext, useRef } from 'react';

import Logo from 'assets/img/midrive-transfer-icon.svg';

import { TagInput } from '@blueprintjs/core';

import Button from 'components/button';
import Spacer from 'components/spacer';
import InputContainer from 'components/input-container';

import LocaleContext from 'contexts/locale-context';
import NotificationContext from 'contexts/notification-context';

import If from 'conditionals/if';

import './index.css';

const ContactForm = ({ onSubmit, loading, showBranding = true }) => {
    const [emails, setEmails] = useState([]);
    const [name, setName] = useState('');
    const [message, setMessage] = useState('');

    const emailInputRef = useRef(null);

    const hasEmails = emails.length > 0;

    const { translations } = useContext(LocaleContext);
    const { setNotification } = useContext(NotificationContext);

    const MAX_NUM_EMAILS = 10;
  
    const pageTranslations = translations.index;
    const jsTranslations = translations.js;

    const onTextChange = setFunc => e => {
        setFunc(e.target.value);
    }
    
    const reset = () => {
        setEmails([]);
        setName('');
        setMessage('');
    }
    
    const onEmailInputKeyPress = e => {
      // Enter pressed
      if(e.keyCode === 13) {
        e.preventDefault();
        return false;
      }

      return true;
    }

    const onEmailInputChange = e => {
      const value = emailInputRef.current.value;
      const COMMA = ',';
      const SPACE = ' ';

      if (value && (value.endsWith(COMMA) || value.endsWith(SPACE))) {
        let separatedVals;

        if (value.includes(COMMA)) {
          separatedVals = value.split(COMMA);
        } else if (value.includes(SPACE)) {
          separatedVals = value.split(SPACE);
        }

        if (onAddEmails(separatedVals)) {
          if (emailInputRef.current) {
            setTimeout(() => emailInputRef.current.value = "", 0)
            e.preventDefault()
          }
        }
      }
    }
      
    /**
       * This will remove invalid and duplicate emails
       * @param {*} emails 
       */
    const cleanEmails = (emails = []) => {
        const trimmedEmails = emails.map(email => email.trim());
      
        return trimmedEmails.filter((email, index, self) => {
          if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return self.indexOf(email) === index
          }
      
          return false;
        });
    }
      
    const onAddEmails = (_emails = []) => {
      console.log();
      const emailsToAdd = [].concat(emails, _emails);
      
      if (_emails.length !== 0) {
        if (emailsToAdd.length > MAX_NUM_EMAILS) {
          setNotification({ autoCancel: true, message: jsTranslations.max_num_emails.replace('#{NUM}', MAX_NUM_EMAILS), type: 'danger' });
          return false;
        } else {
          const cleanedEmails = cleanEmails(emailsToAdd);
          const added = cleanedEmails.length > emails.length;

          if (added) setEmails(cleanedEmails);

          return added;
        }
      }
    }

    const onRemoveEmail = email => {
      setEmails(currentEmails => currentEmails.filter(_email => _email !== email));
    }

    const _onSubmit = async e => {
        e.preventDefault()

        if (emails.length < 1) {
            setNotification({ autoCancel: true, message: jsTranslations.recipient_email_required, type: 'danger' });
        } else if (onSubmit) {
            try {
                await onSubmit({
                    emails,
                    message,
                    name
                })

                reset();
            } catch(e) {}
        }
    }

    return (
        <div className='home__uploaded__input-container'>
          <If condition={showBranding}>
            <img src={Logo} alt='MiDrive logo' className='contact-form__logo'/>

            <h3 className='contact-form__title'>
                MiDrive Transfer
            </h3>
          </If>

          <form className='contact-form' onSubmit={_onSubmit}>
            <InputContainer
              label={pageTranslations.name}
            >
              {({ class: className }) => {
                return (
                  <input
                    onChange={onTextChange(setName)}
                    value={name}
                    className={className}
                    placeholder={pageTranslations.your_name}
                  />
                )
              }}
            </InputContainer>
            <InputContainer
              required
              label={pageTranslations.recipient_email}
            >
              {() => {
                return (
                  <TagInput
                    addOnBlur
                    addOnPaste
                    separator='/[,\n\r\s]/'
                    onAdd={onAddEmails}
                    onKeyDown={onEmailInputKeyPress}
                    values={emails}
                    placeholder={pageTranslations.recipient_email}
                    onRemove={onRemoveEmail}
                    inputRef={ref => emailInputRef.current = ref}
                    onInputChange={onEmailInputChange}
                  />
                )
              }}
            </InputContainer>
            <InputContainer
              label={pageTranslations.your_message}
            >
              {({ class: className }) => {
                return (
                  <textarea
                    value={message}
                    onChange={onTextChange(setMessage)}
                    className={className}
                    placeholder={pageTranslations.your_message}
                    rows='3'
                  />
                )
              }}
            </InputContainer>

            <Spacer size='m'/>

            <Button
              loading={loading}
              disabled={!hasEmails}
              type='submit'
            >
              {pageTranslations.submit}
            </Button>
          </form>
        </div>
    );
};

export default ContactForm;